export const SET_LOADING_STATUS = 'SET_LOADING_STATUS';
export const FETCH_LOGIN_REDUCER = 'FETCH_LOGIN_REDUCER';
export const POST_OAUTH_TOKEN = 'POST_OAUTH_TOKEN';
export const POST_OAUTH_TOKEN_SUCCESS = 'POST_OAUTH_TOKEN_SUCCESS';
export const SET_CITY_COUNTRY_LOADING_STATUS = 'SET_CITY_COUNTRY_LOADING_STATUS';
export const SET_HOTEL_NAME_LOADING_STATUS = 'SET_HOTEL_NAME_LOADING_STATUS';
export const FETCH_CITY_COUNTRY_DATA = 'FETCH_CITY_COUNTRY_DATA';
export const FETCH_CITY_COUNTRY_DATA_FAILED = 'FETCH_CITY_COUNTRY_DATA_FAILED';
export const FETCH_HOTEL_NAME_DATA = 'FETCH_HOTEL_NAME_DATA';
export const FETCH_HOTEL_NAME_DATA_FAILED = 'FETCH_HOTEL_NAME_DATA_FAILED';
export const FETCH_PROPERTY_DETAILS_FOR_CARD = 'FETCH_PROPERTY_DETAILS_FOR_CARD';
export const GET_CLUSTER_HEIRARCHY = 'GET_CLUSTER_HEIRARCHY';
export const CREATE_LEAD = 'CREATE_LEAD';
export const FETCH_CITY_LIST = 'FETCH_CITY_LIST';
export const FETCH_STATIC_DATA = 'FETCH_STATIC_DATA';
export const FETCH_REVERSE_GEOLOCATION = 'FETCH_REVERSE_GEOLOCATION';
export const FETCH_PROPERTY_DETAILS_FOR_CARD_FAILED = 'FETCH_PROPERTY_DETAILS_FOR_CARD_FAILED';
export const POST_SIGN_IN_SUCCESS = 'POST_SIGN_IN_SUCCESS';
export const POST_SIGN_UP_SUCCESS = 'POST_SIGN_UP_SUCCESS';
export const GENERATE_OTP_SUCCESS = 'GENERATE_OTP_SUCCESS';
export const SIGNIN_USER_BY_PHONE = 'SIGNIN_USER_BY_PHONE';
export const SAVE_USER_DETAILS_ON_AUTO_LOGIN = 'SAVE_USER_DETAILS_ON_AUTO_LOGIN';
export const PERSIST_PROPERTY_SEARCH_DATA = 'PERSIST_PROPERTY_SEARCH_DATA';
export const CREATE_LEAD_FAILED = 'CREATE_LEAD_FAILED';
export const CREATE_LEAD_SUCCESS = 'CREATE_LEAD_SUCCESS';
export const SET_HOTEL_NAME = 'SET_HOTEL_NAME';
export const SET_CITY_COUNTRY_NAME = 'SET_CITY_COUNTRY_NAME';
export const CLEAR_PERSISTED_DATA = 'CLEAR_PERSISTED_DATA';
export const FETCH_COUNTRY_LIST = 'FETCH_COUNTRY_LIST';
export const SET_SELECTED_HOTEL = 'SET_SELECTED_HOTEL';
export const FETCH_KYC_FORM_FIELDS = 'FETCH_KYC_FORM_FIELDS';
export const FETCH_PHOTO_ASSIST_CONFIG_SUCCESS = 'FETCH_PHOTO_ASSIST_CONFIG_SUCCESS';
export const FETCH_PHOTO_ASSIST_CONFIG_FAILED = 'FETCH_PHOTO_ASSIST_CONFIG_FAILED';
export const FETCH_PHOTO_TIPS_CONFIG_SUCCESS = 'FETCH_PHOTO_TIPS_CONFIG_SUCCESS';
export const FETCH_PHOTO_TIPS_CONFIG_FAILED = 'FETCH_PHOTO_TIPS_CONFIG_FAILED';
export const FETCH_IMAGES_CONFIG_SUCCESS = 'FETCH_IMAGES_CONFIG_SUCCESS';
export const FETCH_IMAGES_CONFIG_FAILED = 'FETCH_IMAGES_CONFIG_FAILED';
export const FETCH_BUSINESS_IDS_SUCCESS = 'FETCH_BUSINESS_IDS_SUCCESS';
export const FETCH_BUSINESS_IDS_FAILED = 'FETCH_BUSINESS_IDS_FAILED';
export const SET_EMAIL_OTP_LOADING_STATUS = 'SET_EMAIL_OTP_LOADING_STATUS';
export const SET_SELECTED_CITY_COUNTRY = 'SET_SELECTED_CITY_COUNTRY';
export const SEND_OTP_ON_EMAIL_SUCCESS = 'SEND_OTP_ON_EMAIL_SUCCESS';
export const SEND_OTP_ON_EMAIL_FAILED = 'SEND_OTP_ON_EMAIL_FAILED';
export const SET_MOBILE_OTP_LOADING_STATUS = 'SET_MOBILE_OTP_LOADING_STATUS';
export const SEND_OTP_ON_MOBILE_SUCCESS = 'SEND_OTP_ON_MOBILE_SUCCESS';
export const SEND_OTP_ON_MOBILE_FAILED = 'SEND_OTP_ON_MOBILE_FAILED';
export const EMAIL_VERIFY_OTP_SUCCESS = 'EMAIL_VERIFY_OTP_SUCCESS';
export const EMAIL_VERIFY_OTP_FAILED = 'EMAIL_VERIFY_OTP_FAILED';
export const MOBILE_VERIFY_OTP_SUCCESS = 'MOBILE_VERIFY_OTP_SUCCESS';
export const MOBILE_VERIFY_OTP_FAILED = 'MOBILE_VERIFY_OTP_FAILED';
export const GET_KYC_STATIC_DATA = 'GET_KYC_STATIC_DATA';
export const GET_KYC_DETAILS = 'GET_KYC_DETAILS';
export const POST_KYC_DETAILS = 'POST_KYC_DETAILS';
export const FETCH_PROPERTY_ONBOARD_CHECKLIST = 'FETCH_PROPERTY_ONBOARD_CHECKLIST';
export const FETCH_LEAD_DATA = 'FETCH_LEAD_DATA';
export const FETCH_ONBOARDED_DATA = 'FETCH_ONBOARDED_DATA';
export const SET_EWB_STATUS = 'SET_EWB_STATUS';
export const SET_LATEST_UPLOADED_IMAGES = 'SET_LATEST_UPLOADED_IMAGES';
export const CLEAR_LATEST_UPLOADED_IMAGES = 'CLEAR_LATEST_UPLOADED_IMAGES';
export const SET_LEAD_LOADING_STATUS = 'SET_LEAD_LOADING_STATUS';
export const SET_ONBOARDED_LOADING_STATUS = 'SET_ONBOARDED_LOADING_STATUS';
export const FETCH_SELECTED_LEAD_DETAILS = 'FETCH_SELECTED_LEAD_DETAILS';
export const FETCH_PROPERTY_ONBOARDING_PROGRESS = 'FETCH_PROPERTY_ONBOARDING_PROGRESS';
export const FETCH_PROPERTY_AMENITIES = 'FETCH_PROPERTY_AMENITIES';
export const UPDATE_PROPERTY_AMENITIES = 'UPDATE_PROPERTY_AMENITIES';
export const GET_ROOM_CATEGORIES = 'GET_ROOM_CATEGORIES';
export const GET_ROOM_CATEGORIES_INFO = 'GET_ROOM_CATEGORIES_INFO';
export const POST_ROOM_CATEGORIES_INFO = 'POST_ROOM_CATEGORIES_INFO';
export const FETCH_SEARCHED_PLACES = 'FETCH_SEARCHED_PLACES';
export const FETCH_PLACE_DETAILS = 'FETCH_PLACE_DETAILS';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const DELETE_IMAGE_SUCCESS = 'DELETE_IMAGE_SUCCESS';
export const FETCH_PROPERTY_REVIEW_DETAILS = 'FETCH_PROPERTY_REVIEW_DETAILS';
export const FETCH_PROPERTY_REVIEW_IMAGES = 'FETCH_PROPERTY_REVIEW_IMAGES';
export const UPLOAD_IMAGE = 'UPLOAD_IMAGE';
export const GET_PROPERTY_DETAILS = 'GET_PROPERTY_DETAILS';
export const FETCH_SAMPLE_IMAGES_SUCCESS = 'FETCH_SAMPLE_IMAGES_SUCCESS';
export const SET_IMAGE_UPLOAD_STRINGS = 'SET_IMAGE_UPLOAD_STRINGS';
export const FETCH_SAMPLE_IMAGES_FAILED = 'FETCH_SAMPLE_IMAGES_FAILED';
export const SET_COVER_IMAGE = 'SET_COVER_IMAGE';
export const SET_VERIFY_LOADING_STATUS = 'SET_VERIFY_LOADING_STATUS';
export const FETCH_FINAL_CONTRACT = 'FETCH_FINAL_CONTRACT';
export const FETCH_ROOM_COUNT_DETAILS = 'FETCH_ROOM_COUNT_DETAILS';
export const FETCH_TNC_DATA = 'FETCH_TNC_DATA';
export const RESET_CITY_COUNTRY_DATA = 'RESET_CITY_COUNTRY_DATA';
export const RESET_HOTEL_NAME_DATA = 'RESET_HOTEL_NAME_DATA';
export const GET_GLOBAL_INFO = 'GET_GLOBAL_INFO';
export const SET_LOCALE_FETCHING_STATUS = 'SET_LOCALE_FETCHING_STATUS';
export const SIGNOUT_USER_ON_AUTHENTICATION_FAIL = 'SIGNOUT_USER_ON_AUTHENTICATION_FAIL';
export const SET_COMPLETION_PAGE_DATA_LOADING = 'SET_COMPLETION_PAGE_DATA_LOADING';
export const UPLOAD_IMAGES_WIDGET_LOADING_STATE = 'UPLOAD_IMAGES_WIDGET_LOADING_STATE';
export const SAVE_COMPLETION_PAGE_DATA = 'SAVE_COMPLETION_PAGE_DATA';
export const GET_CHECKLIST_PAGE_WIDGET = 'GET_CHECKLIST_PAGE_WIDGET';
export const CHANGE_SELECTED_LANGUAGE = 'CHANGE_SELECTED_LANGUAGE';
export const UPDATE_EMAIL_IN_PROPERTY_DETAILS = 'UPDATE_EMAIL_IN_PROPERTY_DETAILS';
export const GET_SELECTED_IMAGES = 'GET_SELECTED_IMAGES';
export const UPDATE_IMAGES_STATUS = 'UPDATE_IMAGES_STATUS';
export const FETCH_PROPERTY_DETAILS_WIDGET = 'FETCH_PROPERTY_DETAILS_WIDGET';
export const ON_IMAGE_UPLOAD_SUCCESS = 'ON_IMAGE_UPLOAD_SUCCESS';
export const ON_IMAGE_UPLOAD_FAILURE = 'ON_IMAGE_UPLOAD_FAILURE';
export const REMOVE_INACTIVE_IMAGES = 'REMOVE_INACTIVE_IMAGES';
export const UPDATE_IMAGE_PERCENTILE = 'UPDATE_IMAGE_PERCENTILE';
export const FETCH_IMAGE_COMPRESSION_CONFIG = 'FETCH_IMAGE_COMPRESSION_CONFIG';
export const FETCH_CITY_LIST_START = 'FETCH_CITY_LIST_START';
export const FETCH_COUNTRY_LIST_START = 'FETCH_COUNTRY_LIST_START';
export const FETCH_STATIC_DATA_START = 'FETCH_STATIC_DATA_START';
export const FETCH_PROPERTY_DETAILS_WIDGET_START = 'FETCH_PROPERTY_DETAILS_WIDGET_START';
export const FETCH_IMAGES_CONFIG = 'FETCH_IMAGES_CONFIG';
export const FETCH_IMAGE_UPLOAD_PAGE_WIDGETS = 'FETCH_IMAGE_UPLOAD_PAGE_WIDGETS';
export const FETCH_AMENITIES_WIDGET_DATA = 'FETCH_AMENITIES_WIDGET_DATA';
export const FETCH_KYC_FORM_FIELDS_START = 'FETCH_KYC_FORM_FIELDS_START';
export const GET_KYC_STATIC_DATA_START = 'GET_KYC_STATIC_DATA_START';
export const GET_KYC_DETAILS_START = 'GET_KYC_DETAILS_START';

//new actions
export const START_FETCHING_CHECKLIST_NAVIGATION_WIDGET = 'START_FETCHING_CHECKLIST_NAVIGATION_WIDGET';
export const ERROR_FETCHING_CHECKLIST_NAVIGATION_WIDGET = 'ERROR_FETCHING_CHECKLIST_NAVIGATION_WIDGET';
export const SAVE_CHECKLIST_NAVIGATION_WIDGET = 'SAVE_CHECKLIST_NAVIGATION_WIDGET';
export const START_FETCHING_PROPERTY_TYPE_WIDGET = 'START_FETCHING_PROPERTY_TYPE_WIDGET';
export const ERROR_FETCHING_PROPERTY_TYPE_WIDGET = 'ERROR_FETCHING_PROPERTY_TYPE_WIDGET';
export const FETCH_PROPERTY_TYPE_PAGE_WIDGETS = 'FETCH_PROPERTY_TYPE_PAGE_WIDGETS';
export const EXIT_SCREEN_WIDGET = 'EXIT_SCREEN_WIDGET';
export const FETCH_WIDGET = 'FETCH_WIDGET';
export const SET_LOCATION_DETAILS = 'SET_LOCATION_DETAILS';
export const SET_SEARCH_OPTIONS = 'SET_SEARCH_OPTIONS';
export const SET_ADDRESS = 'SET_ADDRESS';
export const GET_COLD_LEAD_DATA = 'GET_COLD_LEAD_DATA';
export const START_FETCHING_REVERSE_GEOLOCATION = 'START_FETCHING_REVERSE_GEOLOCATION';
export const ERROR_FETCHING_REVERSE_GEOLOCATION = 'ERROR_FETCHING_REVERSE_GEOLOCATION';
export const CREATE_OR_UPDATE_PROPERTY = 'CREATE_OR_UPDATE_PROPERTY';
export const CREATE_OR_UPDATE_PROPERTY_SUCCESS = 'CREATE_OR_UPDATE_PROPERTY_SUCCESS';
export const CREATE_OR_UPDATE_PROPERTY_FAILED = 'CREATE_OR_UPDATE_PROPERTY_FAILED';
export const FETCH_PROPERTY_INFO_WIDGET = 'FETCH_PROPERTY_INFO_WIDGET';
export const FETCH_PROPERTY_INFO_WIDGET_SUCCESS = 'FETCH_PROPERTY_INFO_WIDGET_SUCCESS';
export const FETCH_PROPERTY_INFO_WIDGET_FAILED = 'FETCH_PROPERTY_INFO_WIDGET_FAILED';
export const GET_USER_BY_EMAIL_OR_PHONE = 'GET_USER_BY_EMAIL_OR_PHONE';
export const GET_USER_BY_EMAIL_OR_PHONE_SUCCESS = 'GET_USER_BY_EMAIL_OR_PHONE_SUCCESS';
export const START_FETCHING_PROPERTY_INFO_WIDGET = 'START_FETCHING_PROPERTY_INFO_WIDGET';
export const START_FETCHING_LOGIN_PAGE_WIDGET = 'START_FETCHING_LOGIN_PAGE_WIDGET';
export const ERROR_FETCHING_LOGIN_PAGE_WIDGET = 'ERROR_FETCHING_LOGIN_PAGE_WIDGET';
export const SAVE_LOGIN_PAGE_WIDGET = 'SAVE_LOGIN_PAGE_WIDGET';
export const FETCH_KYC_WIDGET_DATA = 'FETCH_KYC_WIDGET_DATA';
export const FETCH_KYC_WIDGET_DATA_SUCCESS = 'FETCH_KYC_WIDGET_DATA_SUCCESS';
export const FETCH_KYC_WIDGET_DATA_FAILED = 'FETCH_KYC_WIDGET_DATA_FAILED';
export const START_FETCHING_TERMS_OF_SERVICE_WIDGET = 'START_FETCHING_TERMS_OF_SERVICE_WIDGET';
export const FETCH_TERMS_OF_SERVICE_WIDGET_SUCCESS = 'FETCH_TERMS_OF_SERVICE_WIDGET_SUCCESS';
export const FETCH_TERMS_OF_SERVICE_WIDGET_FAILED = 'FETCH_TERMS_OF_SERVICE_WIDGET_FAILED';
export const PUBLISH_PROPERTY = 'PUBLISH_PROPERTY';
export const GET_CHECKLIST_SECTION_STATUS = 'GET_CHECKLIST_SECTION_STATUS';
export const SAVE_DISCOUNT_WAIVER_DATA = 'SAVE_DISCOUNT_WAIVER_DATA';
export const UPDATE_START_OYOCHAT_VIA_EXTERNAL_INTENT = 'UPDATE_START_OYOCHAT_VIA_EXTERNAL_INTENT';
export const VERIFY_REFERRAL_CODE = 'VERIFY_REFERRAL_CODE';
export const VERIFY_REFERRAL_CODE_START = 'VERIFY_REFERRAL_CODE_START';
export const VERIFY_REFERRAL_CODE_SUCCESS = 'VERIFY_REFERRAL_CODE_SUCCESS';
export const VERIFY_REFERRAL_CODE_CLEAR = 'VERIFY_REFERRAL_CODE_CLEAR';
export const UPDATE_REFERRAL_CODE = 'UPDATE_REFERRAL_CODE';
export const UPDATE_REFERRAL_LOADING = 'UPDATE_REFERRAL_LOADING';
export const GET_REFERRAL_DETAILS = 'GET_REFERRAL_DETAILS';
export const UPDATE_REFERRAL_DETAILS = 'UPDATE_REFERRAL_DETAILS';
export const UPDATE_COMMON_WIDGETS = 'UPDATE_COMMON_WIDGETS';
